export const bingoBashPage = {
    content: () => import('./BingoBashPage.vue'),
};
